export default "//file.bilionpass.com/japandx-portal/0.1.21/static/img/photo-sprite.9f7e6dac-c60d8f.png";